export default "__VITE_ASSET__B7ljhc6p__"